<template>
    <div class="tr-child">
        <v-btn
            icon
            small

            :class="['icon', {'isClick': isOpenChild }]"
            @click="onChild"
        >
            <svg-sprite width="20" height="20" icon-id="arrow"></svg-sprite>
        </v-btn>
    </div>
</template>

<script>
export default {
	name: "TrChild",
	props: {
		line: Object,
		index: Number,
		isOpenChild: Boolean,
	},
	methods: {
		onChild() {
			this.$emit("updateChild", { line: this.line });
			this.$emit("updateOpen");
		},
	}
};
</script>

<style lang="scss" scoped>
.tr-child {
    .icon {
        transition: all .4s ease-in-out;
        transform: rotate(0deg);
        &.isClick {
            transform: rotate(180deg);
        }
        svg {
            color: #19BC38;
        }
    }
}

</style>
